import CustomScripts from './CustomScripts';

export default CustomScripts;
